import { AI_STUDIO_SUBCATEGORY_NAME } from "@nlc/shared-types";

export function isAiStudioSubcategorySelected(
  subcategories: Array<{ name: string; types: Array<{ id: number }> }>,
  selectedTypeId: number | undefined,
): boolean {
  if (selectedTypeId === undefined) return false;

  return subcategories.some(
    (sub) =>
      sub.name === AI_STUDIO_SUBCATEGORY_NAME &&
      sub.types.some((t) => t.id === selectedTypeId),
  );
}
